import {
	useStarterDashboardV2PageData,
	useStarterDashboardV2PageFcm,
} from 'src/app/pages/starterDashboardV2/pageContext';

type UsePromotionHistoryResult = ModelHookResult<{
	contributionsFormatted: string;
	impressionsTotal: number;
	impressionsTotalFormatted: string;
	promoterCount: number;
	promoterCountFormatted: string;
	signatureCount: number;
	signatureCountFormatted: string;
	shouldUseDonationLanguage: boolean;
}>;
// eslint-disable-next-line complexity
export function usePromotionHistory(): UsePromotionHistoryResult {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const { shouldUseDonationLanguage } = useStarterDashboardV2PageFcm();

	return {
		data: {
			contributionsFormatted: petition.promotionStats?.contributionsFormatted || '0',
			impressionsTotal: petition.promotionStats?.impressionsTotal || 0,
			impressionsTotalFormatted: petition.promotionStats?.impressionsTotalLocalized || '0',
			promoterCount: petition.promotionStats?.promoterCount || 0,
			promoterCountFormatted: petition.promotionStats?.promoterCountLocalized || '0',
			signatureCount: petition.promotionStats?.signatureCount || 0,
			signatureCountFormatted: petition.promotionStats?.signatureCountLocalizedCompact || '0',
			shouldUseDonationLanguage,
		},
	};
}
